const hiddenTabs = async function () {
  try {
    let allTabs = document.querySelectorAll(".gridForm .gridForm__tabs--item");
    allTabs.forEach((item) => item.classList.remove("active"));
  } catch (Exception) {
    console.warn("Exception in hiddenTabs => " + Exception);
  }
};
const hiddenForms = async function () {
  try {
    let allForms = document.querySelectorAll(".gridForm form.form-item");
    allForms.forEach((item) => item.classList.add("d-none"));
  } catch (Exception) {
    console.warn("Exception in hiddenForms => " + Exception);
  }
};

const activeItem = function (element, handle) {
  try {
  } catch (Exception) {
    console.warn("Exception in activeItem => " + Exception);
  }
};

if (document.querySelector(".gridForm")) {
  window.changeTab = async function (event, handle) {
    try {
      event.preventDefault();
      await hiddenTabs();
      await hiddenForms();

      let element = event.target;
      element.classList.add("active");

      let formActive = document.querySelector(
        `.gridForm form[data-handle="${handle}"]`
      );
      formActive.classList.remove("d-none");
    } catch (Exception) {
      console.warn("Exception in changeTab => " + Exception);
    }
  };
  window.changeTabSelect = async function (event) {
    try {
      event.preventDefault();

      await hiddenForms();
      let element = event.target;
      let option = element.options[element.selectedIndex];
      let color = option.dataset.color;
      element.style.backgroundColor = color;
      let handle = element.value;
      let formActive = document.querySelector(
        `.gridForm form[data-handle="${handle}"]`
      );
      formActive.classList.remove("d-none");
    } catch (Exception) {
      console.warn("Exception in changeTabSelect => " + Exception);
    }
  };
}
